// lib/slot-definitions.ts
var SLOT_DEFINITIONS = {
  // -------------------------------------------------------------------------
  // Inline Slots - Render in place within the component tree
  // -------------------------------------------------------------------------
  main: {
    name: "main",
    type: "inline"
  },
  sidebar: {
    name: "sidebar",
    type: "inline"
  },
  dock: {
    name: "dock",
    type: "portal",
    portalTarget: "body",
    zIndex: 850
  },
  // -------------------------------------------------------------------------
  // Portal Slots - Render to document.body via React Portal
  // -------------------------------------------------------------------------
  modal: {
    name: "modal",
    type: "portal",
    portalTarget: "body",
    zIndex: 1e3
  },
  drawer: {
    name: "drawer",
    type: "portal",
    portalTarget: "body",
    zIndex: 900
  },
  overlay: {
    name: "overlay",
    type: "portal",
    portalTarget: "body",
    zIndex: 1100
  },
  center: {
    name: "center",
    type: "portal",
    portalTarget: "body",
    zIndex: 1e3
  },
  toast: {
    name: "toast",
    type: "portal",
    portalTarget: "body",
    zIndex: 1200,
    notification: true
  },
  // -------------------------------------------------------------------------
  // Game HUD Slots - Portal for game overlay UI
  // -------------------------------------------------------------------------
  "hud-top": {
    name: "hud-top",
    type: "portal",
    portalTarget: "body",
    zIndex: 500
  },
  "hud-bottom": {
    name: "hud-bottom",
    type: "portal",
    portalTarget: "body",
    zIndex: 500
  },
  floating: {
    name: "floating",
    type: "portal",
    portalTarget: "body",
    zIndex: 800
  }
};
function getSlotDefinition(slot) {
  return SLOT_DEFINITIONS[slot];
}
function isPortalSlot(slot) {
  return SLOT_DEFINITIONS[slot]?.type === "portal";
}
function isNotificationSlot(slot) {
  return SLOT_DEFINITIONS[slot]?.notification === true;
}
function getSlotsByType(type) {
  return Object.entries(SLOT_DEFINITIONS).filter(([, def]) => def?.type === type).map(([name]) => name);
}
function getInlineSlots() {
  return getSlotsByType("inline");
}
var ALL_SLOTS = Object.keys(SLOT_DEFINITIONS);

export { ALL_SLOTS, SLOT_DEFINITIONS, getInlineSlots, getSlotDefinition, isNotificationSlot, isPortalSlot };
